import { Component, EventEmitter, Inject, Input, OnInit, Optional, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { IntraocularPressureModel } from 'app/EMR/PrimaryExaminationModels/intraocular_pressure.model';
import { EMRService } from 'app/EMR/EMR.service';
import { IoMethods } from 'app/EMR/PrimaryExaminationModels/io_methods.model';
import { DashboardService } from 'app/dashboard/dashboard.service';
import * as moment from 'moment';
import { DatePipe } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'app/auth/auth.service';
import { ChartDataSets, ChartOptions } from 'chart.js';
import { Color, Label } from 'ng2-charts';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-IOP',
  templateUrl: './IOP.component.html',
  styleUrls: ['./IOP.component.scss']
})
export class IOPComponent implements OnInit {
   destroyiol$: Subject<boolean> = new Subject<boolean>();
  private iomethods: IoMethods[] = [];
  private myControl = new FormControl();
 showspinner: boolean = false;
  // myControl2 = new FormControl();
  @Input() showiopmodel:any
  @Output() parentdata :EventEmitter<any> = new EventEmitter();
 
  //filteredOptions: Observable<IoMethods[]>;
  // filteredOptions2: Observable<string[]>;

  private enabledisablebtn: boolean = false;
  private intraocular_pressure_ds: MatTableDataSource<IntraocularPressureModel>



  private displayedColumns_intraocular_pressure: string[] = ['time', 'method', 'od', 'os', 'dl',
    'pachy', 'odpachy', 'ospachy', 'cctod', 'cctos', 'remarks', 'Action'];
    private Ioptime: string;
  private isdilated: number;
  private isdilation: string;
  private  phcheck: number;
  private DLcheck: number;

  private lineChartData: ChartDataSets[] = [
    // { data: [85, 72, 78, 75, 77, 75], label: 'Crude oil prices' },
  ];
  private lineChartData2: ChartDataSets[] = [
    // { data: [85, 72, 78, 75, 77, 75], label: 'Crude oil prices' },
  ];
  private lineChartLabels: Label[] = [];
  private lineChartOptions = {
    responsive: true,
  };
  private lineChartColors: Color[] = [
    {
      borderColor: '#21d59b',
      backgroundColor: 'rgba(255,255,0,0.28)',
    },
  ];
  private lineChartColors2: Color[] = [
    {
      borderColor: '#0058ff',
      backgroundColor: 'rgba(255,255,0,0.28)',
    },
  ];
  lineChartLegend = true;
  lineChartPlugins = [];
  lineChartType = 'line';
  iopDetailsList: any;
  isheader:boolean=false;
  constructor(private emrservice: EMRService, private datePipe: DatePipe,
    private dashboardService: DashboardService, private dialog: MatDialog,
    private authservice: AuthService,
    @Optional() @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<IOPComponent>,
  ) { }

  ngOnInit() {
    if(this.data){
      this.isheader = this.data.isheader;
     }else{
       this.isheader = false;
     }
    this.emrservice.add_io ={};
    // this.intraocular_pressure_ds = new MatTableDataSource (this.emrservice.intraocularpressure.slice().reverse());
    this.iopDetails();
    this.emrservice.share.pipe(takeUntil(this.destroyiol$)).subscribe((x: any) => {
      if (x == 3) {
        this.get_IOP_PE();
      }
    })
    this.emrservice.iopshare.pipe(takeUntil(this.destroyiol$)).subscribe((x: any) => {
      if (x == 'section10') {

        this.get_IOP_PE();
      }
    })
    // this.filteredOptions = this.myControl.valueChanges.pipe(
    //   startWith(''),
    //   map(value => value ? this._filter(value): this.helplistservice.iomethods.slice())
    // );
    this.enabledisablebtn = true;

    // AI Scribe — pre-fill IOP from a voice consultation
    this.emrservice.aiWorkup$.pipe(takeUntil(this.destroyiol$)).subscribe(() => this.consumeAiIop());
    [900, 2200, 3800].forEach((d) => setTimeout(() => this.consumeAiIop(), d));
  }

  /** AI Scribe: add a spoken IOP reading to the IOP grid, then clear. */
  consumeAiIop(): void {
    const p: any = this.emrservice.aiWorkupPending;
    const iop = p && p.primaryExam && p.primaryExam.iop;
    if (!iop || (!iop.re && !iop.le)) { return; }
    const shown = (this.intraocular_pressure_ds && this.intraocular_pressure_ds.data) || [];
    if (shown.some((r: any) => r && r.aiSuggested)) { return; }   // already on screen
    this.emrservice.intraocularpressure = (this.emrservice.intraocularpressure || []).filter((r: any) => !r.aiSuggested);
    this.emrservice.intraocularpressure.push({
      pkTranId: 0, fkVisitId: this.emrservice.visitid,
      iopvalueOd: iop.re || '', iopvalueOs: iop.le || '',
      ioptime: '', remarks: 'AI', isActive: '1', aiSuggested: true,
    } as any);
    this.intraocular_pressure_ds = new MatTableDataSource(this.emrservice.intraocularpressure.slice());
    this.enabledisablebtn = false;
  }

  ngOnDestroy(): void {
    this.destroyiol$.next(true);
    this.destroyiol$.unsubscribe();
    this.iopDetailsList = null;
    this.iomethods = null;
  }
  saveiop_on_server(event) {
    const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
    button.setAttribute('disabled', true); 
    if (this.emrservice.intraocularPressurePermission.isAddPermission == true) {
      // this.emrservice.open_loader_Dialog();
      this.showspinner=true;
      let onlynewrecords = this.emrservice.intraocularpressure.filter(record => record.pkTranId == null || record.pkTranId == 0);
      if (onlynewrecords.length > 0) {
        let payload = {
          IopDetail: onlynewrecords
        }
        this.emrservice.saveiop_on_server(payload).pipe(takeUntil(this.destroyiol$)).subscribe(

          data => this.success_iop(data), err => this.failed_iop(err)
        )
      } else {
        // this.dialog.closeAll();
        this.showspinner = false;
        this.dashboardService.openSnackBar("Please Add The Method Name", "OK");
      }
    } else {
      this.dashboardService.openSnackBar("Add Permission Denied", "OK");
    }
  }
  success_iop(data) {
    this.enabledisablebtn = true;
    // this.emrservice.intraocularpressure = []; 
    // this.dialog.closeAll();
    this.showspinner = false;
    this.emrservice.getPExamStatus();
    this.get_IOP_PE();
    this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
  }

  failed_iop(err) {
    // this.dialog.closeAll();
    this.showspinner = false;
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  get_IOP_PE() {
    this.emrservice.get_iop_list_PE().pipe(takeUntil(this.destroyiol$)).subscribe(
      data => this.success_iop_list(data), err => this.failed_iop_list(err)
    )
  }
  success_iop_list(data) {

    this.emrservice.intraocularpressure = data;

    this.intraocular_pressure_ds = new MatTableDataSource(this.emrservice.intraocularpressure.slice());
    // this.dashboardService.openSnackBar("complaints get successfully", "OK");
  }
  failed_iop_list(err) {
    // this.dashboardService.openSnackBar("get iop list failed ", "OK");
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }


  addiop() {

    let todaysdate = new Date();
    this.emrservice.add_io.ioptime = moment(todaysdate).format("HH:mm");
    this.emrservice.add_io.fkVisitId = this.emrservice.visitid;
    this.emrservice.add_io.pkTranId = 0;
    // this.emrservice.add_io.fkMethodId =0;
    this.enabledisablebtn = false;
    this.emrservice.add_io.isEdit = false;
    this.emrservice.add_io.isDelete = false;
    this.emrservice.add_io.correctedIop = "0.0";
    this.emrservice.add_io.isActive = "true";
    this.emrservice.add_io.iopDate = this.datePipe.transform(todaysdate, "MM-dd-yyyy");
    let methodid = this.iomethods.filter(item => item.pkIopmethodId == this.emrservice.add_io.fkMethodId)[0];
    this.emrservice.add_io.methodName = methodid.methodName;
    this.emrservice.add_io.iopvalueOd = this.emrservice.add_io.iopvalueOd;
    this.emrservice.add_io.iopvalueOs = this.emrservice.add_io.iopvalueOs;
    this.emrservice.add_io.pachyOd = this.emrservice.add_io.pachyOd;
    this.emrservice.add_io.pachyOs = this.emrservice.add_io.pachyOs;
    this.emrservice.add_io.cctod = this.emrservice.add_io.cctod;
    this.emrservice.add_io.cctos = this.emrservice.add_io.cctos;
    this.emrservice.intraocularpressure.push(this.emrservice.add_io);
    this.intraocular_pressure_ds = new MatTableDataSource(this.emrservice.intraocularpressure.slice());
    this.canceladdIOPdetails();
  }

  timeConvt(e) {
    return moment(e, 'HH:mm').format("HH:mm");

  }
  getmethodselect(event) {

    let methodid = event.value;
    this.emrservice.add_io.methodName = methodid.methodName;
    let todaysdate = new Date();
    this.emrservice.add_io.ioptime = moment(todaysdate).format("HH:mm");

  }
  success_delete_iop(data) {
    // this.dialog.closeAll();
    this.showspinner = false ;
    this.get_IOP_PE();
    this.emrservice.getPExamStatus();
    this.dashboardService.openSnackBar("Record Deleted Successfully", "OK");
  }

  failed_delete_iop(err) {
    // this.dialog.closeAll();
    this.showspinner = false;
    // this.dashboardService.openSnackBar("iop delete api failed", "OK");
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  deleteiop(row) {
    //  console.log("delete id " + row.pkComplaintId);
   
    if (row.pkTranId > 0) {
      if (this.emrservice.intraocularPressurePermission.isDeletePermission == true) {
        // this.emrservice.open_loader_Dialog();
        this.showspinner = true;
        row.isEdit = true
        row.isDelete = true
        let payload = {
          IopDetail: [row]
        }
        this.emrservice.delete_iop_PE(payload).pipe(takeUntil(this.destroyiol$)).subscribe(
          data => this.success_delete_iop(data), err => this.failed_delete_iop(err)
        )
      } else {
        this.dashboardService.openSnackBar("Delete Permission Denied", "OK");
      }
    }
    else {
      const index: number = this.emrservice.intraocularpressure.indexOf(row);
      if (index !== -1) {
        this.emrservice.intraocularpressure.splice(index, 1);
        this.intraocular_pressure_ds = new MatTableDataSource(this.emrservice.intraocularpressure.slice());
      }
      // this.dialog.closeAll();
      this.showspinner = false;
    }

  }


  addIOPdetails() {
    if (this.emrservice.intraocularPressurePermission.isAddPermission == true) {
    this.emrservice.getiomethods(0,0).pipe(takeUntil(this.destroyiol$)).subscribe(
      data => this.success_methods(data), err => this.failed_methods(err)
    );
    }else{
      this.dashboardService.openSnackBar("Add Permission Denied", "OK");
    }
  }
  success_methods(data) {
    this.iomethods = data;
    this.emrservice.add_io.isDilated = false;
    this.emrservice.add_io.isWithPachy = false;
    document.getElementById("addIOPModal").style.display = "block";
    // console.log ("methods " + this.iomethods);
  }
  failed_methods(err) {
    this.emrservice.add_io.isDilated = false;
    this.emrservice.add_io.isWithPachy = false;
    document.getElementById("addIOPModal").style.display = "block";
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  canceladdIOPdetails() {
    document.getElementById("addIOPModal").style.display = "none";
    this.emrservice.add_io = {};
  }

  onRadioButtonChange(event) {

    this.emrservice.add_io.isDilated = event.value;

  }
  RadioButtonChange(event) {
   
    this.emrservice.add_io.isWithPachy = event.value;
    if (this.emrservice.add_io.isWithPachy == false) {
      this.emrservice.add_io.cctod = '';
      this.emrservice.add_io.cctos = '';
    }
  }

  iopGraphViewModal() {
    this.iopDetails();
    if (this.emrservice.intraocularPressurePermission.isAddPermission == true) {
      document.getElementById("iopGraphViewModal").style.display = "block";
      // this.lineChartData = [
      //   {
      //     data: [1, 1, 4, 5, 5, 3, 1],
      //     label: 'Industry Average',
      //     fill: false
      //     // tension: 0,
      //   },
      //   { data: [5, 5, 5, 2, 1, 3, 3], label: 'ACME', fill: false },
      // ]; 
    } else {
      this.dashboardService.openSnackBar("Add Permission Denied", "OK");
    }
  }
  canceliopGraphViewModal() {
    document.getElementById("iopGraphViewModal").style.display = "none";
  }
  iopDetails() {
    let ODvalue = [];
    let OSvalue = [];
    let labelName = [];
    this.emrservice.getIOPDetails().pipe(takeUntil(this.destroyiol$)).subscribe(data => {
      this.iopDetailsList = data;
      if (this.iopDetailsList.length > 0) {
        this.iopDetailsList.forEach(element => {
          ODvalue.push(element.iopvalueOd);
          OSvalue.push(element.iopvalueOs);
          if (element.visitDate != null) {
            labelName.push(this.datePipe.transform(element.visitDate, 'dd/MM/yyyy'));
          }
        });
      }
    },err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
    this.lineChartLabels = labelName;
    this.lineChartData = [
      { data: ODvalue, label: 'OD', borderColor: '#21d59b', borderWidth: 2, fill: false }
    ];
    this.lineChartData2 = [
      { data: OSvalue, label: 'OS', borderColor: '#0058FF', borderWidth: 2, fill: false }
    ];
  }
  closedialog(){
    this.dialogRef.close();
  }
}
